import { Component, inject, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IconsService } from './services/icons.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { OffcanvasNavbarComponent } from 'src/app/components/offcanvas/offcanvas-navbar.component';
import { STORAGE_KEYS, StorageService } from '../services/storage.service';

@Component({
  selector: 'app-navbar',
  template: `
    <header class="navbar navbar-expand-lg bd-navbar bg-zazz-gold shadow-sm sticky-top d-sm-block d-md-none">
      <nav class="container-xxl bd-gutter flex-wrap flex-lg-nowrap justify-content-between">
        <div class="bd-navbar-toggle">
          <!-- button class="navbar-toggler border-0 text-dark" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDarkNavbar" aria-controls="offcanvasDarkNavbar" aria-label="Toggle navigation" (click)="open()">
            <span class="navbar-toggler-icon"></span>
          </button -->
        </div>
        <!-- a class="navbar-brand p-0 me-0 me-lg-2" href="#"><img src="assets/images/logo-zazz.png" width="44px"></a -->
        
        <div class="d-flex"></div>
        <div class="container">
          <div class="row mb-2 mt-2">
            <div class="col-10">
              <p class="text-start text-light" style="font-size: 16px;">Hola, {{user?.name}}</p>
            </div>            
          </div>
          <div class="row text-light">
            <div class="col-4 text-center" routerLink="/tenant/invoices/{{user?.id}}">
              <fa-icon [icon]="icons.faFile"></fa-icon>
              <p class="text-sm mb-1" style="line-height: 1;">Mis facturas</p>
            </div>
            <div class="col-4 text-center" routerLink="/tenant/consume/{{user?.id}}">
              <fa-icon [icon]="icons.faChartLine"></fa-icon>
              <p class="text-sm mb-1" style="line-height: 1;">Historico de consumo</p>
            </div>
            <div class="col-4 text-center" routerLink="/tenant/bills/{{user?.id}}">
              <fa-icon [icon]="icons.faFileInvoiceDollar"></fa-icon>
              <p class="text-sm mb-1" style="line-height: 1;">Pagar servicio</p>
            </div>
          </div>
        </div>
      </nav>
    </header>
  `,
  styleUrls: []
})
export class NavbarComponent {
  @Input() user: any;  
  @Input() profileLogo: any;

  permissions: any;
  profile: any;

  roleLS: any = {};

  isNavbarCollapsed = true;

  protected version = environment.app_version;
  storageService = inject(StorageService);
  constructor(
    private router: Router,
    public icons: IconsService,
    private offcanvasService: NgbOffcanvas
  ) {}

  open() {
    const offcanvasRef = this.offcanvasService.open(OffcanvasNavbarComponent, { 
      position: 'end', 
      animation: true, 
      backdrop: true, 
      keyboard: true,
      scroll: true, 
      backdropClass: 'bg-dark', 
      panelClass: 'bg-sidebar-dark' 
    });
    offcanvasRef.result.then((result) => {
      
    }).catch((error) => {
      
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user'] && changes['user'].currentValue) {
      this.user = this.user;
    }
  }

  signOut() {
    let redirect = this.roleLS?.group_id == 3 ? '/user/sign-in' : '/ingresar';
    this.storageService.removeItem(STORAGE_KEYS.TOKEN);
    this.storageService.removeItem(STORAGE_KEYS.USER);
    this.storageService.removeItem(STORAGE_KEYS.PROFILE);
    this.storageService.removeItem(STORAGE_KEYS.AVATAR);
    this.storageService.removeItem(STORAGE_KEYS.PERMISSIONS);
    this.storageService.removeItem(STORAGE_KEYS.ROLE);
    this.storageService.removeItem(STORAGE_KEYS.FCM_TOKEN);
    //
    window.location.href = redirect;
    // window.location.reload();
  }
}
